import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findCrimes = (headers, params) => {
    let query = buildQuery(params, []);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/crime${query}`, { headers });
};

export const findCrimeById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/crime/${id}`, { headers });
};
